import useCartState from '@order/hooks/useCartState'
import SavedOrderDiscountsScreen from '@screens/order/discounts/SavedOrderDiscounts'
import { Redirect, useLocalSearchParams } from 'expo-router'
import { useMemo } from 'react'

export default function DiscountsPage() {
  const { id } = useLocalSearchParams<{ id: string }>()

  const cart = useCartState((s) => s.orders)

  const order = useMemo(() => {
    return cart.find((o) => o.id === id)
  }, [cart, id])

  if (!order) {
    return <Redirect href="/checkout" />
  }

  return <SavedOrderDiscountsScreen order={order} />
}
